import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API, saveAuthTokens } from '../App';

export default function GitHubCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const code = searchParams.get('code');
    if (code) {
      processGitHubAuth(code);
    } else {
      navigate('/login');
    }
  }, []);

  const processGitHubAuth = async (code) => {
    try {
      const res = await API.post('/api/auth/github/callback', { code });
      saveAuthTokens(res.data);
      window.location.href = '/dashboard';
    } catch (err) {
      console.error('GitHub auth failed:', err);
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#FF4D00] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#A0A0A0] text-sm font-mono">Connecting GitHub...</p>
      </div>
    </div>
  );
}
